import { Fire } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { POPULAR_ITEM_MINIMUM_SAVE_COUNT } from '@/components/ItemSave/ItemSave.constants';
import { useAppFormatMessageWithValues } from '@/utils/intl/useAppFormatMessage';

type Props = {
    className?: string;
    savedCount: number;
    showSavedCount: boolean;
};

export const ItemSaveBadge = ({ className, savedCount = 0, showSavedCount = false }: Props) => {
    const formatMessageWithValues = useAppFormatMessageWithValues();

    if (showSavedCount && savedCount > 0) {
        return (
            <section className={cn('flex flex-col', className)}>
                <BodySecondary
                    className="flex items-center gap-2xs"
                    color="secondary"
                >
                    {savedCount >= POPULAR_ITEM_MINIMUM_SAVE_COUNT && (
                        <Fire
                            color="critical"
                            size="sm"
                            style="fill"
                        />
                    )}
                    {formatMessageWithValues('bidder_saved_item_count', { savedCount })}
                </BodySecondary>
            </section>
        );
    }
    return null;
};
